import React from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'
import { formatPrice } from '../../../../utils/formats'
import RadioButtonOrCheckbox from '../../Products/Utils/RadioButtonOrCheckbox'

function Option({ option, isSelected, isMultiSelectionAllowed, onClick, onMouseEnter, onMouseLeave }) {
  return (
    <div className={isSelected ? `${styles.optionWrapper} ${styles.optionWrapperSelected}` : styles.optionWrapper}
            key={option.name}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
    >
      <div className={styles.optionTitleWrapper}>
        <div className={styles.optionTitle}>
          <RadioButtonOrCheckbox
            isSelected={isSelected}
            checkboxStyle={isMultiSelectionAllowed}
          />
          <Text type="body-short-1">{option.name}</Text>
        </div>
        <Text type="body-short-1">{formatPrice(option.price)}</Text>
      </div>
      <div className={styles.optionItems}>
        { option.includedItems.map(i => <Text type="body-short-1" key={i.name}>{i.name}</Text>) }
      </div>
    </div>
  )
}

export default Option
